export const initialState = {
  dailyUsageHistory: []
};

export const analyticsStateAction = {
  UPDATE_DAILY_USAGE: "analytics/UPDATE_DAILY_USAGE",
  ADD_DAILY_USAGE_HISTORY: "analytics/ADD_DAILY_USAGE_HISTORY"
};
